'use strict';

/**
 * Filter component view
 *
 * @category   View
 * @module     collection.edit
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var FilterComponentView = require('modules/base/views/layout/filter-component');

var template = require('modules/collection/templates/components/filter/finding-date.hbs');

var FindingDateView = FilterComponentView.extend({
    template: template,

    ui: {
        'rangeStart': '.component-range-start',
        'rangeEnd': '.component-range-end',
        'clearRange': '.clear-range',
        'multipleOptions': '.component-filter-buttons input[type="checkbox"]',
    },

    events: {
        'change @ui.rangeStart': 'change',
        'change @ui.rangeEnd': 'change',
        'click @ui.clearRange': 'clearRange',
        'change @ui.multipleOptions': 'change',
    },

    getFilters: function() {
        var filters = [];

        var startValue = this.ui.rangeStart.val();
        var endValue = this.ui.rangeEnd.val();
        var multipleOptions = this.ui.multipleOptions.filter(':checked');

        if (
            startValue !== this.ui.rangeStart.find('option:first').val() ||
            endValue !== this.ui.rangeEnd.find('option:last').val()
        ) {
            filters.push({value: startValue + '~' + endValue, displayName: startValue + ' — ' + endValue});
        }

        multipleOptions.each(function(index, option){
            option = $(option);
            filters.push({value: option.val(), displayName: option.next('label').text().trim()});
        });

        return filters;
    },

    setFilters: function(filters) {
        filters = filters.split(',');

        this.ui.rangeStart.closest('.filter-range').removeClass('active');

        filters.forEach(function(filter){
            if (filter.indexOf('~') > -1) {
                var rangeValues = filter.split('~');
                this.ui.rangeStart.val(rangeValues[0]);
                this.ui.rangeEnd.val(rangeValues[1]);
                this.ui.rangeStart.closest('.filter-range').addClass('active');
            } else {
                this.ui.multipleOptions.each(function(index, option){
                    $(option).prop('checked', $(option).val() === filter);
                });
            }
        }.bind(this));
    },

    clearRange: function(event) {
        this.ui.rangeStart.val(this.ui.rangeStart.find('option:first').val());
        this.ui.rangeEnd.val(this.ui.rangeEnd.find('option:last').val());
        this.change();

        //@todo investigate who calls navigate on button if default is not prevented
        event ? event.preventDefault() : null;
    },

    resetFilters: function() {
        this.ui.multipleOptions.each(function(index, option){
            $(option).prop('checked', false);
        });

        this.clearRange();
        this.change();
    },

    getFilterValueDisplayName: function(value) {
        if (value === 'none') {
            return App.t('collection::object:finding-date:none:short-title');
        }

        return value.replace('~', ' — ');
    },
});

module.exports = FindingDateView;